<template>
  <div class="dashboards">
    <div class="content-wrapper">
      <RouterView />
    </div>
  </div>
</template>
